import type {
  AgentStatusParams,
  LiveHelperAction,
} from '@oneToOne/agentStatus/params'
import { EventType } from '@oneToOne/agentStatus/tracking/eventType'

import { customEvent } from '@core/customEvent'
import { pruneNilValues } from '@core/object'
import { sendPixelTrackingWithSession } from '@core/tracking/senders'
import type { PixelTrackingEndpoint } from '@core/tracking/types'

import { CLICK_WIDGET, EMBED_IMPRESSION, EMBED_INSTANCE } from './endpoints'

const track = (
  endpoint: PixelTrackingEndpoint,
  params: AgentStatusParams,
  payload?: Record<string, string | boolean | undefined>,
) => {
  sendPixelTrackingWithSession({
    host: params.api_host_tracking,
    endpoint,
    data: {
      event_properties: pruneNilValues({
        _chat_channel_id: params?.chat_channel_id,
        embed_instance_id: params?.widget_id,
        ...payload,
      }),
    },
  })
}

/**
 * Embed instance tracking of Agent Status widget
 */
export const trackEmbedInstance = (params: AgentStatusParams) => {
  track(EMBED_INSTANCE, params)
}

/**
 * Embed impression tracking of Agent Status widget
 */
export const trackEmbedImpression = (
  params: AgentStatusParams,
  offline: boolean,
) => {
  track(EMBED_IMPRESSION, params, {
    offline,
  })
  customEvent({
    type: EventType.FW_AGENT_STATUS_IMPRESSION,
    data: { widget_id: params.widget_id },
  })
}

/**
 * Click tracking of Agent Status widget
 */
export const trackWidgetClick = (
  params: AgentStatusParams,
  action: LiveHelperAction,
  offline: boolean,
) => {
  track(CLICK_WIDGET, params, {
    action,
    offline,
  })
}
